import { transformUserManagePrivacySettingsAllowed } from '../transformers/manage-user-privacy-settings-allowed';
import { type CustomResolversContext } from '../types';

const UserManagePrivacySettingsAllowed = async (
	_: any,
	args: { userId: string },
	context: CustomResolversContext,
	info: any,
) => {
	const { userId } = args;
	const url = `${context.url.stargateRoot}/users/${userId}/manage/privacy-settings/allowed`;
	return context
		.fetch(url)
		.then((data) => data.json())
		.then((data) => transformUserManagePrivacySettingsAllowed(data));
};

export default UserManagePrivacySettingsAllowed;
